import { useMemo } from 'react';

import { useJourneyActions } from 'api/journey-actions/hooks';
import { useJourney } from 'api/journeys/hooks';
import { useJourneyContext } from 'ui/journey-builder/base-builder';

export const useLiveTargetIds = (journeyShortId: string): Set<string> => {
  const { data: actions } = useJourneyActions(journeyShortId);
  const { data: journey } = useJourney(journeyShortId);
  const { journeyForms, webhooks, emailTriggers, pollingConfigs } = useJourneyContext();

  return useMemo(() => {
    return new Set(
      [
        ...(actions ?? []),
        ...(journey?.attributes ?? []),
        ...journeyForms,
        ...webhooks,
        ...emailTriggers,
        ...pollingConfigs,
      ].map((item) => item.shortId),
    );
  }, [actions, journey?.attributes, journeyForms, webhooks, emailTriggers, pollingConfigs]);
};
